import request from "../axios";

export const getResourcesByPatient = (patient_id: string) => request.get(`/api/patient/${patient_id}/resources`);